import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import _ from 'lodash';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import TsdiClient from 'src/models/AP/Client';
import AltSubCode from 'src/models/AP/AltSubcode';
import TsdiSubcode from 'src/models/AP/Subcode';
import TsdiAltSubcode from 'src/models/AP/AltSubcode';

interface IAddAltSubcodeDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onCancel?: () => void;
    onAddNewProject?: (payload: ProspectDetails) => void;
    updateAltSubcode?: (payload: TsdiAltSubcode) => void;
    resetProjectSearchOptions?: () => void;
    setProjectSearchTerm?: (keyword: string) => void;
    incrementProjects?: () => void;
    projects?: ProspectDetails[];
    subcode?: TsdiSubcode;
    setSelectedAltSubcode?: (project: TsdiAltSubcode) => void;
    setSelectedClient?: (project: TsdiClient) => void;
    style?: React.CSSProperties;
    addNewSubcode?: boolean;
    defaultProject?: number;
    mileageRate?: number;
    dayRate?: number;
    clientNumber?: number;
    projectNumber?: number;
    clientTypes?: { code: number, description: string}[];
    setAddingAltSubcode?: (addingAltSubcode: boolean) => void;
}

const AddAltSubcodeDialog = (props: IAddAltSubcodeDialogProps) => {
    const { register, errors, getValues } = useForm();
    const [fetchNextAltSubcodesPage, setFetchNextAltSubcodesPage] = useState<boolean>(true);
    const [altSubcodeSearchOptions, setAltSubcodeSearchOptions] = useState<ODataOptions>(undefined);
    const [altSubcodeSearchTerm, setAltSubcodeSearchTerm] = useState<string>('');
    const [altSubcodes, setAltSubcodes] = useState<Array<TsdiSubcode>>(undefined);
    const [selectedAltSubcode, setSelectedAltSubcode] = useState<number>(null);
    const { get, post, response } = useFetch();
    const paged: boolean = false;
    // const dispatch = useDispatch();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!altSubcodeSearchOptions) {
            getAltSubCodes();
        }
    }, [altSubcodeSearchOptions]);

    useEffect(() => {
        if ((!!altSubcodeSearchTerm || altSubcodeSearchTerm === '') && !!altSubcodeSearchTerm) {
            resetAltSubcodeSearchOptions();
        }
    }, [altSubcodeSearchTerm]);

    const onCreate = () => {        
        initializeClientSearchSettings();
    };

    const resetState = () => {
        setSelectedAltSubcode(!!props?.defaultProject ? props?.defaultProject : 1);
        setAltSubcodeSearchTerm('');
        resetAltSubcodeSearchOptions();
    };

    const OKClicked = () => {
        props.setSelectedAltSubcode(altSubcodes[selectedAltSubcode]);
        props.hideDialog();
        resetState();
    };

    const onAltSubcodeSearchChanged = (searchContent: string) => {
        search();
    };

    const onCancel = () => {
        props.hideDialog();        
        resetState();
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 1000,
            idField: 'UN_ID',
            pageNumber: 1,
            columns: []
        };
        setAltSubcodeSearchOptions(ODataOptions.from(tableConfig).addOrderBy('UN_NO', ODataOrderByDirection.Ascending));
    };

    const getScrollStatus = (divElement: HTMLDivElement) => {
        if (divElement && !!paged) {
            const scrollTop = divElement.scrollTop % 1 > .9 ? divElement.scrollTop : Math.round(divElement.scrollTop);
            const scrollHeight = divElement.scrollHeight;
            const clientHeight = divElement.clientHeight;

            // Check if reached the end of the list
            if (scrollTop + clientHeight >= scrollHeight) {
                incrementProjects();
                console.log('end of scroll YES');
            } else {
                console.log('end of scroll NO');
            }
        }
    };

    const incrementProjects = () => {
        if (!!fetchNextAltSubcodesPage) {
            let newSearchOptions = _.cloneDeep(altSubcodeSearchOptions);
            newSearchOptions.incrementPageNumber();
            setAltSubcodeSearchOptions(newSearchOptions);
        }
    };

    const selectAltSubcodeAndClose = (altsubcode: TsdiAltSubcode) => {
        props.setSelectedAltSubcode(altsubcode);
        props.hideDialog();
        resetState();
    };

    const resetAltSubcodeSearchOptions = () => {
        setFetchNextAltSubcodesPage(true);
        console.log(fetchNextAltSubcodesPage);
        let newProjectSearchOptions = _.cloneDeep(altSubcodeSearchOptions);
        newProjectSearchOptions.clearFilters();
        newProjectSearchOptions.addPaging(1, 1000);
        if (typeof altSubcodeSearchTerm === 'string') {
            const fieldValues = altSubcodeSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0])) && fieldValues[0] !== ' ' && fieldValues[0]?.length > 0) {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UN_NO]', ODataFilterOperators.Equals, !!altSubcodeSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[2] !== undefined && fieldValues[1]?.length > 0 && fieldValues[1] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UN_NAME]', ODataFilterOperators.Contains, !!altSubcodeSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined && !isNaN(Number(fieldValues[2])) && fieldValues[1] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[GROSS_ACRES]', ODataFilterOperators.Equals, !!altSubcodeSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined && fieldValues[3]?.length > 0 && fieldValues[3] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UNIT_AFE_NO]', ODataFilterOperators.Contains, !!altSubcodeSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined && fieldValues[4]?.length > 0 && fieldValues[4] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[COST_CENTER]', ODataFilterOperators.Contains, !!altSubcodeSearchTerm ? fieldValues[4] : ''));
            }
        }
        setAltSubcodeSearchOptions(newProjectSearchOptions);
    };

    const AddAltSubCode = async (payload: AltSubCode) => {
        const subcodeId = payload?.subcodeId;
        if (!!subcodeId) {
            let result = await post(`/v1.0/ClientProjectMaintenance/subcode/$(subcodeId)/altsubcode`, payload);

            if (response.ok && result) {
                getAltSubCodes();
            }

            props?.hideDialog();
        }
    };

    const getAltSubCodes = async () => {
        const subCodeId = props?.subcode?.id;
        const queryOptions = altSubcodeSearchOptions.toString();
        if (subCodeId > 0) {
            let result = await get(`/v1.0/ClientProjectMaintenance/subcode/${subCodeId}/altsubcodes${!!queryOptions ? queryOptions : ''}`);

            if (response.ok) {
                setAltSubcodes(result);
            } else {
                setAltSubcodes([]);
                console.log('Unable to get subcode data!');
            }
        }
    };

    const search = _.debounce(() => {
        const formData = getValues();
        let searchString =  (!!formData?.searchSubcodeNumber ? formData.searchSubcodeNumber : ' ');
        searchString += ',' +  (!!formData?.searchAltSubcodeName ? formData.searchAltSubcodeName : ' ');
        searchString += ',' +  (!!formData?.searchAltSubcodeName ? formData.searchAltSubcodeName : ' ');
        searchString += ',' + (!!formData?.searchAltSubcodeGrossAcres ? formData.searchAltSubcodeGrossAcres : ' ');
        searchString += ',' + (!!formData?.searchAltSubcodeAfeNumber ? formData.searchAltSubcodeAfeNumber : ' ');
        searchString += ',' + (!!formData?.searchAltSubcodeCostCenter ? formData.searchAltSubcodeCostCenter : ' ');
        setAltSubcodeSearchTerm(searchString);
    }, 700);

    const onCreateAltSubcode = () => {
        const subCodeId = !!props?.subcode?.id ? props.subcode.id : undefined;
        if (subCodeId === undefined) {
            return;
        }
        const payload = getValues();
        const transformedPayload = new TsdiAltSubcode();
        transformedPayload.subcodeId = subCodeId;
        transformedPayload.name = payload.searchSubcodeName;
        transformedPayload.grossAcres = !isNaN(Number(payload.searchSubcodeGrossAcres)) ? Number(payload.searchSubcodeGrossAcres) : 25.00;
        transformedPayload.afeNumber = payload.searchSubcodeAfeNumber;
        transformedPayload.costCenter = payload.searchSubcodeCostCenter;
        AddAltSubCode(transformedPayload);
    };

    return (
        <>
        <Dialog title={!!props.addNewSubcode ? 'Add Alt Subcode' : 'Find Alt Subcode'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ maxHeight: '75vh', width: '50%' }}>
        <form>
            <div style={{display: 'inline-block', marginTop: '1rem'}}>
                <div>
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    labelOnLeft={true}
                    label="Client #"
                    name={'searchClientNumber'}
                    style={{width: '40px'}}
                    register={register}
                    disabled={!!props.addNewSubcode ? true : false}
                    defaultVal={!!props?.clientNumber ? props?.clientNumber?.toString() : ''}
                />
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    labelOnLeft={true}
                    label="Project #"
                    name={'searchProjectNumber'}
                    style={{width: '40px'}}
                    register={register}
                    disabled={!!props.addNewSubcode ? true : false}
                    defaultVal={!!props?.projectNumber ? props?.projectNumber?.toString() : ''}
                />
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    labelOnLeft={true}
                    label="Subcode #"
                    name={'searchSubcodeNumber'}
                    style={{width: '40px'}}
                    register={register}
                    disabled={!!props.addNewSubcode ? true : false}
                    defaultVal={!!props?.subcode?.number ? props.subcode.number?.toString() : ''}
                />
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    labelOnLeft={true}
                    label="Alt Subcode #"
                    name={'searchAltSubcodeNumber'}
                    style={{width: '40px'}}
                    register={register}
                    disabled={!!props.addNewSubcode ? true : false}
                    defaultVal={!!selectedAltSubcode ? selectedAltSubcode?.toString() : ''}
                />
                </div>
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    labelOnLeft={true}
                    label="Name"
                    name={'searchAltSubcodeName'}
                    style={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline', width: '50%'}}
                    bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline', width: '55%'}}
                    register={register}
                />
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    label={'Gross Acres'}
                    labelOnLeft={true}
                    name={'searchAltSubcodeGrossAcres'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    label={'AFE #'}
                    labelOnLeft={true}
                    name={'searchAltSubcodeAfeNumber'}
                    register={register}
                />
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    label={'Cost Center'}
                    labelOnLeft={true}
                    name={'searchAltSubcodeCostCenter'}
                    register={register}
                /> 
            </div>
            <div style={{marginTop: '3rem', overflowY: 'hidden', maxHeight: '200px'}}>
                    {props.addNewSubcode && <div style={{fontWeight: 'bold', fontFamily: 'Arial', width: '100%', textAlign: 'center'}}>
                        Existing Alt Subcodes
                    </div>}
                    <table>
                        <thead style={{ textAlign: 'left' }}>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Cost Center</th>
                                <th>Gross Acres</th>
                            </tr>
                        </thead>
                        <tbody onScroll={(event) => getScrollStatus(event.currentTarget)}>
                        {altSubcodes && altSubcodes?.map((altSubcode: TsdiAltSubcode, index: number) => {
                            return (
                                    // tslint:disable-next-line
                                    <tr key={altSubcode.number + index} onDoubleClick={() => selectAltSubcodeAndClose(altSubcode)} onClick={() => setSelectedAltSubcode(index) } className="table-item-hover" style={{ textAlign: 'left' }}>
                                        <td style={{ width: '7%' }}>
                                            <RHFInputBox
                                                name={`newAltSubcodeNumber`}
                                                defaultVal={altSubcode?.number?.toString()}
                                                type="text"
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '30%' }}>
                                            <RHFInputBox
                                                name={`newAltSubcodeName`}
                                                defaultVal={altSubcode?.name}
                                                type="text"
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '30%' }}>
                                            <RHFInputBox
                                                name={`newAltSubcodeCostCenter`}
                                                defaultVal={altSubcode?.costCenter}
                                                type="text"
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '30%' }}>
                                            <RHFInputBox
                                                name={`newAltSubcodeGrossAcres`}
                                                defaultVal={altSubcode?.grossAcres.toString()}
                                                type="text"
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </form>
            <div className="form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                {!!props.addNewSubcode && <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Save New Alt Subcode'}
                    onClick={() => onCreateAltSubcode()}
                />}
                {!props.addNewSubcode && <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />}
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => onCancel()}
                />
            </div>
        </Dialog>
        </>
    );
};

export default AddAltSubcodeDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/AddAltSubcodeDialog.tsx